<template>
  <div id="changelog">
    <h3 class="ui header">{{ $t('CHANGELOG') }}</h3>
    <changelog-list
      class="diffList"
      :typename="'flow'"
      :isDoubleSelect="true"
      :itemId="flow.id"
      @changeChosen="onChangeChosen"
      :revert="onRevert"
      :editorMode="editorMode"
      :selectChangeOnLoad="true"
      :isEditDisabled="isEditDisabled"
      :sinceVersion="sinceVersion"
    />
    <changelog-diff-header
      :class="{ dark: isDarkThemeActive }"
      class="diffHeader"
      :originalValue="originalValue"
      :modifiedValue="modifiedValue"
    />

    <div class="monaco-border" :class="{ dark: isDarkThemeActive }">
      <monaco-diff-editor
        id="monacoEditor"
        :originalValue="originalValue.code || ''"
        :modifiedValue="modifiedValue.code || ''"
        :readonly="true"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../../../scss/variables';

#changelog {
  display: grid;
  grid-template-columns: 350px 1fr 1fr;
  grid-template-rows: auto auto 1fr;
  grid-template-areas:
    'title title title'
    'listing header header'
    'listing diffview diffview';
  column-gap: 15px;
  row-gap: 10px;

  .header {
    grid-area: title;
  }

  .diffList {
    grid-area: listing;
    display: flex;
  }

  .diffHeader {
    grid-area: header;
  }

  .monaco-border {
    grid-area: diffview;

    padding: 10px;
    border-radius: 5px;
    &.dark {
      background-color: #1e1e1e;
    }
  }
}
</style>

<script>
// @flow
import ChangelogDiffHeader from './ChangelogDiffHeader'
import ChangelogList from '../../../Changelog/ChangelogList'
import { Flow } from 'services'
import { mapFields } from 'vuex-map-fields'
import MonacoDiffEditor from '../CodeEditor/MonacoDiffEditor'
import { mapGetters } from 'vuex'

export default {
  name: 'changelog',
  components: { ChangelogDiffHeader, ChangelogList, MonacoDiffEditor },

  props: {
    isEditDisabled: {
      type: Boolean,
      default: () => false
    }
  },

  computed: {
    ...mapFields('flowEditor', {
      flowEditorCode: 'flow.editorCode',
      flowCode: 'flow.code',
      flowBlocklyXml: 'flow.blocklyXml',
      flowVersion: 'flow.version'
    }),
    ...mapGetters('flowEditor', ['isDarkThemeActive']),
    flow() {
      return this.$store.state.flowEditor.flow
    },
    app() {
      return this.$store.state.flowEditor.app || {}
    },
    editorMode() {
      return this.$store.state.flowEditor.editorMode
    },
    sinceVersion() {
      return this.$route.params.modeArg
    }
  },

  data() {
    return {
      originalValue: {},
      modifiedValue: {}
    }
  },

  methods: {
    onChangeChosen(original, modified) {
      this.originalValue = _.isEmpty(original)
        ? {}
        : {
            code: original.descriptive
              ? original.descriptive.editorCode || original.descriptive.code
              : '',
            tag: original.tag,
            ts: original.ts
          }

      this.modifiedValue = _.isEmpty(modified)
        ? {}
        : {
            code: modified.descriptive
              ? modified.descriptive.editorCode || modified.descriptive.code
              : '',
            tag: modified.tag,
            ts: modified.ts
          }
    },
    onRevert(revertedData) {
      this.flowCode = revertedData.descriptive.code
      this.flowEditorCode = revertedData.descriptive.editorCode
      this.flowBlocklyXml = revertedData.descriptive.blocklyXml || ''

      return Flow.updateFlow(this.flow.id, this.flow).then(res => {
        this.flowVersion = res.version
        this.$emit(
          'flowReverted',
          {
            es5Code: this.flowCode,
            code: revertedData.descriptive.editorCode,
            sourcemap: revertedData.descriptive.sourcemap
          },
          this.flowVersion,
          this.flowBlocklyXml
        )
        this.$router.push({
          name: 'app-flow',
          params: { appId: this.app.id, flowId: this.flow.id, mode: 'auto' }
        })
      })
    },
    refreshComponentData() {
      this.originalValue = {}
      this.modifiedValue = {}
    }
  }
}
</script>
